<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor='5'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import {mapState} from 'vuex'
import MemberAdd from '../../../../static/form/MemberAdd.vue'
import MemberLB from '../assembly/MemberLB.vue'
import MemberLBs from '../assembly/MemberLBs.vue'
import MemberLBss from '../assembly/MemberLBss.vue'
export default {
  components: {
    MemberAdd,
    MemberLB,
    MemberLBs,
    MemberLBss
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [],
      addobj: {
        title: '添加会员',
        name: '2',
        closable: true,
        content: MemberAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.settabletabs()
  },
  methods: {
    settabletabs()
    {
      let userInfo = JSON.parse(localStorage.getItem('userMsg'))
      if (userInfo.userno === 'kyxxfwpt' || userInfo.userno === 'kycylhh')
      {
        this.editableTabs.push(
          {
            title: '企业会员列表',
            name: '1',
            closable: false,
            ref: 'child',
            content: MemberLB
          })
      }
      else
      {
        this.editableTabs.push({
          title: '个人会员列表',
          name: '1',
          closable: false,
          ref: 'child',
          content: MemberLB
        },
        {
          title: '企业会员列表',
          name: '3',
          closable: false,
          ref: 'child',
          content: MemberLBs
        },
        {
          title: '专家会员列表',
          name: '4',
          closable: false,
          ref: 'child',
          content: MemberLBss
        })
      }
    },
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/Membergl.vue